import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { forkJoin } from 'rxjs';
import { BranchHttpService } from '../http/branch-http.service';
import { ProductHttpService } from '../http/product-http.service';
import { SectionHttpService } from '../http/section-http.service';

@Injectable({
    providedIn: 'root',
})
export class SectionListHttpResolverService implements Resolve<any> {
    constructor(private sectionHttpService: SectionHttpService) {}
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.sectionHttpService.getAllSections();
    }
}

@Injectable({
    providedIn: 'root',
})
export class SectionNewHttpResolverService implements Resolve<any> {
    constructor(private productHttpService: ProductHttpService) {}
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.productHttpService.getAllProducts();
    }
}

@Injectable({
    providedIn: 'root',
})
export class SectionEditHttpResolverService implements Resolve<any> {
    constructor(private sectionHttpService: SectionHttpService, private productHttpService: ProductHttpService) {}
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let getAllProducts = this.productHttpService.getAllProducts();
        let getSectionById = this.sectionHttpService.getSectionById(route.params.id);
        return forkJoin([getSectionById, getAllProducts]);
    }
}
